import { GalleryModel } from '../models/gallery/gallery.model';
import { GalleryStylingModel } from '../models/gallery/gallery-styling.model';

export const /** @type {?} */ GalleryTemplates = {
  defaultTemplate: {
    property: new GalleryModel({
      display: true,
      disable: false,
      options: {
        width: '100%',
        imagePercent: 75,
        imageArrowsAutoHide: true,
        thumbnailsPercent: 25,
        thumbnailsColumns: 3,
        thumbnailMargin: 8,
        thumbnailsMargin: 8,
        thumbnailsArrowsAutoHide: true,
        previewFullscreen: true
      }
    })
  }
}
